import * as React from 'react';
import { checkValue } from 'src/components/common/helper';
import { ModuleProps } from 'src/utils/module-util';
import { CTAPageNavComponent } from 'src/components/common/modules/v1/cta-page-nav/code-split/cta-page-nav-component';

// Css Style Import
import(/* webpackChunkName: "v1-cta-page-nav-styles" */ 'src/components/common/modules/v1/cta-page-nav/styles/cta-page-nav.css');

const CTAPageNavComponentModule = (props: ModuleProps) => {
  const { content } = props;
  const contents = checkValue(content, true) ? content?.map((data, i) => ({ ...data, id: `${data.module}_${i}` })) : [];

  return <CTAPageNavComponent {...props} content={contents} />;
};

export { CTAPageNavComponentModule };
